import { render, staticRenderFns } from "./editName.vue?vue&type=template&id=cb7c7cfe&scoped=true"
import script from "./editName.vue?vue&type=script&lang=js"
export * from "./editName.vue?vue&type=script&lang=js"
import style0 from "./editName.vue?vue&type=style&index=0&id=cb7c7cfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7c7cfe",
  null
  
)

export default component.exports